import React, { useState } from 'react';

import { useParams } from 'react-router-dom';

import ArmReportPageHeader from './components/ArmReportPageHeader';
import ArmReportTable from './components/ArmReportTable';

const ArmReport = (): JSX.Element => {
  const { type } = useParams<{ type: string }>();

  const lastMonth = new Date();
  lastMonth.setDate(0);

  const [month, setMonth] = useState<Date | null>(lastMonth);

  const [orderingValue, setOrderingValue] = useState<string>('-revenue');

  const armType = type !== 'paying' && type !== 'total' ? 'total' : type;

  return (
    <>
      <ArmReportPageHeader
        type={armType}
        lastMonth={lastMonth}
        month={month}
        setMonth={setMonth}
        orderingValue={orderingValue}
      />

      <ArmReportTable type={armType} month={month} setOrderingValue={setOrderingValue} />
    </>
  );
};

export default ArmReport;
